const checkEmail = value => {
  const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (value?.match(emailRegex)) {
    return null;
  }
  return "Value can only include `a`s, `.`s, and `@`s.";
};

export default checkEmail;
